export default function formatPersonName(person) {
    if (!person) return ''
    return `${person.givenName} ${person.familyName}`
}